import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/notification/thunks/clear-notification.ts
var clearNotification = createAsyncThunk(thunkTypes.CLEAR_NOTIFICATION, async (_param, { dispatch }) => {
	dispatch(actions.clear());
});
//#endregion
export { clearNotification };

//# sourceMappingURL=clear-notification.js.map